import { isValidObject } from "helpers/validation"
import service from "./service"
import constants from "../constants"
import draftLogic from "./draftLogic"

/*
  DraftOpenShift: 'DraftOpenShift',
  DraftVTO: 'DraftVTO',
  DraftInventory: 'DraftInventory',
  DraftUnregisteredInventory: 'DraftUnregisteredInventory',
  ParentOpenShift: 'ParentOpenShift',
  ChildOpenShift: 'ChildOpenShift',
  ParentVTO: 'ParentVTO',
  ChildVTO: 'ChildVTO',
  Inventory: 'Inventory',
  TeamShift: 'TeamShift',
  Unknown: 'Unknown',
*/

const shouldShowSectionTab = (shiftObject) => {
    if ( isValidObject(shiftObject) == true) {
       if ( shiftObject?.name == 'open_shift' && shiftObject?.trade_status != 'unpublished_posted' ){
            return true
       } else if ( shiftObject?.name == 'shift_vto' && shiftObject?.trade_status != 'unpublished_posted' ){
            return true
       } else if ( shiftObject?.name == 'shift' ){
            return true
       } 
    } 
    return false
}

const shouldShowApplicantsTabOnDetail = (shift) => {
    const subtype = service.getShiftSubType(shift);
    if( subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.TeamShift){
        return true
    }
    return false
}

const shouldShowCommentsTabOnDetail = (shift) => {
    const subtype = service.getShiftSubType(shift);
    if( subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ChildVTO ){
        return true
    }else if ( subtype == constants.ShiftSubType.TeamShift ){
        return false 
    }
    return false
}

const shouldShowChildCardHeader = (subtype) => {
    return (subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ChildVTO || subtype == constants.ShiftSubType.TeamShift) 
}

const shouldShowPillTags = (subtype) => {
    return (subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.ParentVTO)
}

const postingOrViewingBulkShift = (assignToTarget, subtype) => {
    return service.isPostingBulkShifts(assignToTarget) && 
        (subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.DraftOpenShift || 
         subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO || 
         subtype == constants.ShiftSubType.Unknown)
}

const shouldShowQuantityField = (assignToTarget, subtype) => {
    return postingOrViewingBulkShift(assignToTarget, subtype)
}

const shouldShowPostToGroupField = (assignToTarget, subtype) => {
    return postingOrViewingBulkShift(assignToTarget, subtype)
}

const shouldShowDescriptionField = (assignToTarget, subtype) => {
    return postingOrViewingBulkShift(assignToTarget, subtype) || subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ChildVTO || subtype == constants.ShiftSubType.TeamShift
}

const shouldShowSelectWeekdayField = (subtype) => {
    return subtype == constants.ShiftSubType.Unknown
}

const shouldShowSaveButton = (subtype, presentedShift, assignToTarget) => {
    if( subtype == constants.ShiftSubType.TeamShift ){
        if ( isValidObject(presentedShift) && isValidObject(assignToTarget) ){
            return presentedShift.taker_id != assignToTarget.owner_id
        }
        return false
    }else{
        return ( subtype == constants.ShiftSubType.DraftOpenShift || 
            subtype == constants.ShiftSubType.ParentOpenShift ||
            subtype == constants.ShiftSubType.ParentVTO ||
            subtype == constants.ShiftSubType.DraftVTO ||
            subtype == constants.ShiftSubType.DraftInventory ||
            subtype == constants.ShiftSubType.DraftUnregisteredInventory )
    }
}

const shouldShowCopyButton = (subtype, isViewingShift) => {
    return (isViewingShift == true && ( subtype !== constants.ShiftSubType.ChildVTO));
}

const shouldShowSkillField = (subtype, isSkillsConfigured) => {
    return (subtype == constants.ShiftSubType.ParentOpenShift || 
        subtype == constants.ShiftSubType.DraftOpenShift || 
        subtype == constants.ShiftSubType.ParentVTO || 
        subtype == constants.ShiftSubType.DraftVTO ||
        subtype == constants.ShiftSubType.ChildOpenShift ||
        subtype == constants.ShiftSubType.ChildVTO ||
        subtype == constants.ShiftSubType.Unknown) && isSkillsConfigured == true
}

const shouldShowRoleField = (subtype, shift, roles) => {
    // Check if any IDs in non_filter_tag_ids or filter_tag_ids match a role with tag_type 'role'
    if (shift && roles && Array.isArray(roles)) {
        const shiftTagIds = [
            ...(shift.non_filter_tag_ids || []),
            ...(shift.filter_tag_ids || [])
        ];
        
        const hasRoleTag = roles.some(role => 
            role.tag_type == 'role' && shiftTagIds.includes(role.id)
        );
        
        if (hasRoleTag) {
            return true;
        }
    }
    // Default to showing position field
    if( subtype == constants.ShiftSubType.Unknown) { 
        return true; 
    }else{ 
        return false; 
    }
}

const disableAssignToField = (subtype) => {
    return (subtype !== constants.ShiftSubType.Unknown && subtype !== constants.ShiftSubType.TeamShift)
}

const disableTimeField = (presentedShift) => {
    return isValidObject(presentedShift) == true && draftLogic.isDraftShift(presentedShift) == false ;
}

const disablePositionField = (subtype) => {
    return (subtype == constants.ShiftSubType.ChildOpenShift  || subtype == constants.ShiftSubType.ChildVTO || subtype == constants.ShiftSubType.TeamShift || subtype == constants.ShiftSubType.Inventory)
}

const disableRoleField = (subtype) => {
    return (subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.TeamShift || subtype == constants.ShiftSubType.Inventory 
        || subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.ChildVTO)
}

const disableSkillField = (subtype) => {
    return (subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.TeamShift || subtype == constants.ShiftSubType.Inventory 
        || subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.ChildVTO)
}

const disableDescriptionField = (subtype) => {
    return (subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ChildVTO || subtype == constants.ShiftSubType.TeamShift || subtype == constants.ShiftSubType.Inventory)
}

const disablePostToGroupField = (subtype) => {
    return (subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.ChildVTO)
}

const shouldShowDeleteButton = (subtype, presentedShift, locationSettings) => {
    return (presentedShift.allow_delete === true) || ( isRevokableChildShift(subtype, locationSettings) == true )
}

const isRevokableChildShift = (subtype, locationSettings) => {
    const result = ( (subtype == constants.ShiftSubType.ChildOpenShift || subtype == constants.ShiftSubType.ChildVTO) && locationSettings.cfg__allow__revoke == 1)
    return result
}

const shouldShowCTAForSelectedApplicant = (selectedApplicant) => {
    return selectedApplicant == null || (selectedApplicant != null && (selectedApplicant?.status == 'applied' || selectedApplicant?.status == 'nominated') )
}

const canHighlightApplicant = (shift, selectedApplicant) => {
    if( selectedApplicant == null ){ return false; }
    const status = selectedApplicant?.status;

    if( shift.name == 'open_shift' || shift.name == 'shift_vto' ) {
        return status != 'denied';
    }else if ( shift.name == 'shift' ) {
        if ( shift.trade_status == 'approved' || shift.trade_status == 'covered' ){
            return status == 'picked';
        }else {
            return status != 'denied';
        }
    }
}

const classNameForManagedApplicant = (selectedApplicant) => {
    if( selectedApplicant == null ){ return ''; }
    const status = selectedApplicant?.status;
    if( status == 'picked' ){
        return 'approved-applicant';
    }else if ( status == 'denied' ){
        return 'denied-applicant';
    }else{
        return ''
    }
} 

const shouldShowApplicantListOnFirstLoad = (presentedShift) => {
    if (presentedShift?.name == 'open_shift' && presentedShift.current_applicants_pending_user_ids.length > 0){
        return true;
    }else if (presentedShift?.name == 'shift_vto' && presentedShift.current_applicants_pending_user_ids.length > 0){
        return true;
    }else if (presentedShift?.name == 'shift' && (presentedShift.current_applicants_pending_user_ids.length > 0 || presentedShift.current_applicants_picked_user_ids > 0) ){
        return true;
    }else{
        return false;
    }
}

const shouldShowSingleHeaderAvatar = (shift) => {
    if (shift?.name == 'open_shift' && shift.current_applicants_picked_user_ids.length > 0){
        return true;
    }else if (shift?.name == 'shift_vto' && shift.current_applicants_picked_user_ids.length > 0){
        return true;
    }else if (shift?.name == 'shift' && (shift.current_applicants_pending_user_ids.length == 0 && shift.current_applicants_picked_user_ids.length == 0) ){
        return true;
    }else{
        return false;
    }
}

const shouldShowOnlyOneAvatarForCommentHeader = (shift) => {
    if ( shift?.name == 'open_shift' || shift?.name == 'shift_vto' ){
        return true;
    }
    return false;
}

const getManageApplicantActionType = (shift, willApproveApplicant) => {
    if( willApproveApplicant == false ){
        return constants.ManageApplicantActionType.deny;
    }else{
        if( shift?.name == 'open_shift' || shift?.name == 'shift_vto' ){
            if( shift.current_applicants_picked_user_ids.length + 1 == shift.total_shifts_available ){
                return constants.ManageApplicantActionType.approveLast;
            }
        }else if ( shift?.name == 'shift' ){
           return constants.ManageApplicantActionType.approveLast; 
        }
        return constants.ManageApplicantActionType.approve;
    }
}

const showOpenShiftForAssignList = (isOpenShiftConfigured, subtype) => {
    return (isOpenShiftConfigured == true && (subtype == constants.ShiftSubType.Unknown || subtype == constants.ShiftSubType.ParentOpenShift || subtype == constants.ShiftSubType.DraftOpenShift) )
}

const showVTOForAssignList = (isVTOConfigured, subtype) => {
    return (isVTOConfigured == true && (subtype == constants.ShiftSubType.Unknown || subtype == constants.ShiftSubType.ParentVTO || subtype == constants.ShiftSubType.DraftVTO) )
}

export default {
    shouldShowApplicantsTabOnDetail,
    shouldShowCommentsTabOnDetail,
    shouldShowSectionTab,
    shouldShowChildCardHeader,
    shouldShowPillTags,
    shouldShowQuantityField,
    shouldShowPostToGroupField,
    shouldShowDescriptionField,
    shouldShowSelectWeekdayField,
    shouldShowSaveButton,
    disableAssignToField,
    disableTimeField,
    disablePositionField,
    disableRoleField,
    disableDescriptionField,
    disablePostToGroupField,
    shouldShowDeleteButton,
    isRevokableChildShift,
    classNameForManagedApplicant,
    shouldShowCTAForSelectedApplicant,
    shouldShowApplicantListOnFirstLoad,
    shouldShowSingleHeaderAvatar,
    canHighlightApplicant,
    shouldShowOnlyOneAvatarForCommentHeader,
    getManageApplicantActionType,
    showOpenShiftForAssignList,
    showVTOForAssignList,
    shouldShowCopyButton,
    postingOrViewingBulkShift,
    shouldShowSkillField,
    disableSkillField,
    shouldShowRoleField,
}